import i18n from 'i18n'

import { PRODUCT_TYPES } from 'constants/productTypes'
import HBasic from 'assets/products/h-basic.png'
import HPlus from 'assets/products/h-plus.png'
import HUltra from 'assets/products/h-ultra.png'
import HUltraLocked from 'assets/products/h-ultra-locked.png'
import NextGen from 'assets/products/next-gen.png'
import NextGenLocked from 'assets/products/next-gen-locked.png'

export function productByType({ type, unlock = true }) {
  if (type === PRODUCT_TYPES[0] && unlock) return HBasic
  if (type === PRODUCT_TYPES[1] && unlock) return HPlus
  if (type === PRODUCT_TYPES[2] && unlock) return HUltra
  if (type === PRODUCT_TYPES[2] && !unlock) return HUltraLocked
  if (type === PRODUCT_TYPES[3] && unlock) return NextGen
  if (type === PRODUCT_TYPES[3] && !unlock) return NextGenLocked

  return HUltraLocked
}

export const productName = (product) => i18n.t(`product_names.${product}`)
